// extracted by mini-css-extract-plugin
export default {"infosContainer":"infox_infosContainer__jRb9Z","infosItem":"infox_infosItem__7YeyF","aiHighlight":"infox_aiHighlight__S18Ev","title":"infox_title__pRIC3","descr":"infox_descr__zG5Ma"};